import { ConfigProvider, Table } from "antd";
import { DotLoading, InfiniteScroll } from "antd-mobile";
import React from "react";
import { useTranslation } from "react-i18next";
import vars from "../../assets/styles/_variables.scss";
import "./style.scss";

const CustomTable = ({
  scrollX = Math.min(window.innerWidth, vars.maxWidthInPc),
  customClass = "",
  columns = [],
  ...props
}) => {
  const { t } = useTranslation();
  //! must set every column width when you define columns

  const InfiniteScrollContent = ({ hasMore }) => {
    return (
      <>
        {hasMore ? (
          <>
            <DotLoading />
          </>
        ) : (
          <span>{t("mobile.infiniteScroll.bottom")}</span>
        )}
      </>
    );
  };

  return (
    <ConfigProvider renderEmpty={() => t("normal.nodata")}>
      <div className={`table-container ${customClass}`}>
        <Table
          pagination={false}
          sticky={{ offsetHeader: 0 }}
          scroll={{
            x: scrollX,
          }}
          size={"small"}
          {...props}
          columns={columns.filter(
            (col) => col.hideInTable === undefined || col.hideInTable === false,
          )}
        />
      </div>
      {props.showInifineScroll ? (
        <InfiniteScroll threshold={20} loadMore={props.loadMore} hasMore={props.hasMore}>
          <InfiniteScrollContent hasMore={props.hasMore} />
        </InfiniteScroll>
      ) : (
        <></>
      )}
    </ConfigProvider>
  );
};

export default CustomTable;
